import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { resetFilter } from '../../../../redux/actions/newFilter';
import { getListPartner } from '../../redux/actions/delivery';

import PartnerList from './PartnerList.page';

const mapStateToProps = state => ({
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
  partnerList: state.delivery.partnerList,
  partnerFilter: state.delivery.partnerFilter,
  loading: state.delivery.loading,
});

const mapDispatchToProps = {
  resetFilter,
  getListPartner,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PartnerList));
